import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Settings from './Settings';



class Driver extends Component {
    render () {
        return (
            <Switch>
                <Route path="/settings" exact component={ Settings } />
            </Switch>
        )
    }
}

export default Driver;



// WEBPACK FOOTER //
// ./src/components/Settings/index.js